/* ================================================================
   Essential Sticky Add to Cart: show the MOBILE bar only after the
   shopper has scrolled past 100vh.
   Upload as: assets/sm-sticky-atc-gate.js
   Load from layout/theme.liquid:
     <script src="{{ 'sm-sticky-atc-gate.js' | asset_url }}" defer="defer"></script>
   Pairs with the CSS block in 260903_sm-custom-sticky-atc.css (sm-custom.css).
   Notes: docs/projects/website/notes.md

   How it works
   - The app injects <form id="essential-sticky-cart-form-mobile"> client-side
     with hashed class names, so nothing is targeted by class. The script
     finds the form, climbs to its fixed/sticky ancestor (the bar) and marks
     it with data-sm-sticky-bar. A MutationObserver re-marks it if the app
     re-renders.
   - On scroll/resize it toggles html.sm-past-100vh as soon as the page
     has scrolled at all, i.e. the bottom of the screen is past 100vh
     (SHOW_AFTER_PX below; phones only. On wider screens the class is
     always on so the CSS never hides the bar there).
   ================================================================ */
(function () {
  'use strict';

  if (window.__smStickyAtcGateInitialized) return;
  window.__smStickyAtcGateInitialized = true;

  var FORM_ID = 'essential-sticky-cart-form-mobile';
  var BAR_ATTR = 'data-sm-sticky-bar';
  var HTML_CLASS = 'sm-past-100vh';
  var SHOW_AFTER_PX = 1; /* scroll distance before the bar appears */
  var mobile = window.matchMedia('(max-width: 767px)');
  var ticking = false;

  function findBar() {
    var form = document.getElementById(FORM_ID);
    if (!form) return null;
    var el = form;
    while (el && el !== document.body) {
      var position = window.getComputedStyle(el).position;
      if (position === 'fixed' || position === 'sticky') return el;
      el = el.parentElement;
    }
    return form;
  }

  function markBar() {
    var bar = findBar();
    if (bar && !bar.hasAttribute(BAR_ATTR)) bar.setAttribute(BAR_ATTR, '');
  }

  function update() {
    ticking = false;
    var scrolled = window.scrollY || window.pageYOffset || 0;
    var past = mobile.matches ? scrolled >= SHOW_AFTER_PX : true;
    document.documentElement.classList.toggle(HTML_CLASS, past);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  if (mobile.addEventListener) {
    mobile.addEventListener('change', update);
  } else if (mobile.addListener) {
    mobile.addListener(update);
  }

  function start() {
    markBar();
    update();
    if (window.MutationObserver) {
      new MutationObserver(markBar).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
